import {
    playerRepository,
    teamRepository,
    transactionManager
} from "../storage/storage";
import PersistenceError from "./exceptions/persistence-error";
import Team from "../sports/common/team";

class TeamService {
    async saveTeam(jsonTeam) {
        try {
            const team = Object.assign(new Team(), jsonTeam);
            return transactionManager.transaction(
                "rw",
                [teamRepository, playerRepository],
                async () => {
                    team.id = await teamRepository.put(team);
                    team.players.forEach((p) => {
                        p.teamId = team.id;
                    });
                    await playerRepository.bulkPut(team.players);

                    return this.getTeam(team.id);
                }
            );
        } catch (err) {
            throw new PersistenceError(err);
        }
    }

    async getTeams() {
        return await teamRepository.getAll().toArray();
    }

    async getTeam(id) {
        const [team, players] = await Promise.all([
            teamRepository.where("id").equals(id).first(),
            playerRepository
                .where("teamId")
                .equals(id)
                .filter((p) => !p.deleted)
                .toArray()
        ]);
        return Object.assign(new Team(), { ...team, players });
    }

    async getTeamById(teamId) {
        return teamRepository.where("teamId").equals(teamId).first();
    }

    async createTeam(team) {
        try {
            const teamId = await teamRepository.put(team);
            return teamRepository.getById(teamId);
        } catch (err) {
            throw new PersistenceError(err);
        }
    }
}

export default new TeamService();
